(function () {
  function init() {
    const body = document.body;

    body.addEventListener('click', (e) => {
      // Intercept clicks on the checkout button inside the drawer
      const checkoutButton = e.target.closest('button[name=checkout]') || e.target.closest('#Checkout');

      if (checkoutButton) {
        const globeWidget = document.querySelector('.cart-drawer__summary');
        if (!globeWidget) return;

        // Is a shipping option selected?
        const isSelected = globeWidget.querySelector('input[type=radio]:checked');

        // Look for an existing inline error block
        let errorMessage = globeWidget.querySelector('.custom-checkout-error');

        if (!isSelected) {
          e.preventDefault();
          e.stopPropagation();

          if (!errorMessage) {
            errorMessage = document.createElement('div');
            errorMessage.className = 'custom-checkout-error';
            errorMessage.style.color = '#ba2c2c';
            errorMessage.style.fontSize = '12px';
            errorMessage.style.fontWeight = '500';
            errorMessage.style.letterSpacing = '0.05em';
            errorMessage.style.textTransform = 'uppercase';
            errorMessage.style.textAlign = 'center';
            errorMessage.style.marginBottom = '15px';
            errorMessage.style.width = '100%';
            errorMessage.style.fontFamily = 'inherit';
            errorMessage.style.transition = 'all 0.2s ease';
            errorMessage.innerText = 'Please choose a delivery method before checking out.';

            checkoutButton.parentNode.insertBefore(errorMessage, checkoutButton);
          } else {
            errorMessage.style.animation = 'none';
            errorMessage.offsetHeight;
            errorMessage.style.animation = 'elegantNudge 0.4s ease-in-out';
          }
        } else if (errorMessage) {
          errorMessage.remove();
        }
      }
    }, true);

    body.addEventListener('change', (e) => {
      if (e.target.matches('.cart-drawer__summary input[type=radio]')) {
        const globeWidget = document.querySelector('.cart-drawer__summary');
        if (globeWidget) {
          const errorMessage = globeWidget.querySelector('.custom-checkout-error');
          if (errorMessage) {
            errorMessage.style.opacity = '0';
            setTimeout(() => errorMessage.remove(), 200);
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
